import { PageLayoutProps, PageLayoutWidth } from '@ms/yammer-web-core-ui/dist/components/PageLayout';
import { PageContextValue } from 'components/PageContext';
import { useMemo } from 'react';

type UsePageLayoutContentSidebarProps = (pageContext: PageContextValue) => PageLayoutProps;
export const usePageLayoutContentSidebarProps: UsePageLayoutContentSidebarProps = (pageContext) =>
  useMemo(() => {
    const baseProps = {
      showContentSidebarAriaLabel: pageContext.showContentSidebarAriaLabel,
    };

    return {
      ...baseProps,
      isPanelExternallyControlled: true,
      isPanelOpen: pageContext.isContentPanelOpen,
      showContentPanelButtonForWidths: [PageLayoutWidth.Small],
      closePanel: pageContext.closeContentPanel,
      openPanel: pageContext.openContentPanel,
    };
  }, [pageContext]);
